import React from 'react';

/**
 * This table is used for sections such as Battery Life, Usage History, Location History, and Water changes and can be used
 * for another tables as long as their styles matches with the tables mentioned before.
 *
 * @param {Array} columns - Array of strings with the title of the columns
 * @param {Array} data - Array of data per row
 * @param {String} title - Title of the table
 * @returns
 */
const Table = ({ columns, data, title }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full mt-2 bg-white text-black text-xs md:text-sm lg:text-md xl:text-md border-collapse">
        <thead>
          <tr key={title} className="bg-[#DBDBDB] rounded-t-lg">
            {columns.map((col) => (
              <th key={col.field} className="py-4 px-4">
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => {
            return (
              <tr key={row.id} className="text-center">
                {columns.map((col) => (
                  <td
                    key={`${col.field}-${row.id}`}
                    className="py-4 px-4 border-b-2 last:border-r-0"
                  >
                    {row[col.field]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default React.memo(Table);
